<template>
  <div>
    <h4 class="text-center text-lighter font-weight-normal mt-5 mb-0">Password reset</h4>
    <form class="my-5">
      <b-form-group label="New password" :feedback="errors.password" :invalid-feedback="errors.password">
        <b-input v-model="password" :state="!errors.password" type="password" required />
      </b-form-group>
      <b-form-group label="Verification code" :feedback="errors.token" :invalid-feedback="errors.token">
        <b-input v-model="token" :state="!errors.token" type="text" required />
      </b-form-group>
      <b-btn variant="primary" :block="true" class="mt-4" @click="request">Reset password</b-btn>
    </form>
    <div class="text-center text-muted">
      <router-link :to="{ name: 'login' }">Sign In</router-link>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import escape from 'lodash/escape'

export default {
  name: 'password-reset',
  data: () => ({
    password: '',
    token: '',
    errors: {}
  }),
  methods: {
    ...mapActions('auth', ['passwordReset']),
    validate() {
      this.$set(this, 'errors', {})
      let isValid = true
      if (!this.token.length) {
        this.errors.token = 'Token required'
        isValid = false
      }

      if (!this.password.length) {
        this.errors.password = 'Password required'
        isValid = false
      }
      return isValid
    },
    request() {
      if (this.validate()) {
        this.passwordReset({ token: this.token, password: this.password })
          .then((r) => {
            this.$appToast.success(escape(r.data.message))
            let email = this.$route.query.email
            // replace: the reset link is spent, back to it would only show an expired token
            this.$router.replace({ name: 'login', query: { email } })
          })
          .catch((error) => {
            // set errors
            if (error.response && error.response.status === 422) {
              this.$set(this, 'errors', {})
              let errors = error.response.data.errors
              for (let errorField in errors) {
                this.errors[errorField] = errors[errorField].join('')
              }
            } else {
              throw error
            }
          })
      }
    }
  },
  created() {
    if (this.$route.query && this.$route.query.token) {
      this.token = this.$route.query.token
    }
  }
}
</script>

<style scoped></style>
